import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import Welcome from '../views/Welcome'
import APIDoc from '../views/APIDoc'
import NoPage from '../views/404'

import AddApprovalNode from '../views/AddApprovalNode.vue';

import HomeWorkPage from '../views/HomeWorkPage.vue';

import Layout from "../views/Layout/Layout";
const _import = require('@/router/_import_' + process.env.NODE_ENV)//获取组件的方法

import LoginCallbackView from "../views/LoginCallbackView";
import AttenBigScreen from "../views/AttenBigScreen";
import TeacherAttenBigScreen from "../views/KaoQinTeacher/TeacherAttenBigScreenView";
import LeaveBigScreen from "../views/LeaveBigScreen";
import LeaveOutBigScreen from "../views/LeaveOutBigScreen";
import DismissalBigScreen from "../views/DismissalBigScreenAuto";
import DismissalBigScreenAuto from "../views/DismissalBigScreenAuto";
import SchoolInfoScreen from "../views/SchoolInfoScreen";
import MoralEducationBigScreen from "../views/MoralEducationBigScreen";
import MoralPointBigScreen from "../views/MoralPointBigScreen";
import ZheshangFiveEducationScreen from "../views/ZheshangBigScreen/FiveEducationScreen";
import ZheshangStudentPortraitScreen from "../views/ZheshangBigScreen/StudentPortraitScreen";


Vue.use(Router)

const createRouter = () => new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/404', component: NoPage, name: 'NoPage',
            meta: {
                title: 'NoPage',
                requireAuth: false,
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/AddApprovalNode', component: AddApprovalNode, name: 'AddApprovalNode',
            meta: {
                title: '审批节点',
                requireAuth: false,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/HomeWorkPage', component: HomeWorkPage, name: 'HomeWorkPage',
            meta: {
                title: '作业公式',
                requireAuth: false,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },

        {
            path: '/AttenBigScreen', component: AttenBigScreen, name: 'AttenBigScreen',
            meta: {
                title: '考勤大屏',
                requireAuth: false,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/TeacherAttenBigScreen', component: TeacherAttenBigScreen, name: 'TeacherAttenBigScreen',
            meta: {
                title: '教师考勤大屏',
                requireAuth: false,
                NoNeedHome: true
            },
            hidden: true
        },
        {
            // 旧链接兼容：跳转到无后台壳的独立静态页，避免 TV 加载整站 Vue。创建于 2026-10-17
            path: '/DormBigScreen',
            name: 'DormBigScreen',
            component: { render: (h) => h('div') },
            beforeEnter(to) {
                const base = (process.env.BASE_URL || '/').replace(/\/+$/, '')
                const search = to.fullPath.includes('?') ? '?' + to.fullPath.split('?')[1] : ''
                const api = (process.env.VUE_APP_BASE_API || '').replace(/\/+$/, '')
                let q = search
                if (api && api !== window.location.origin) {
                    q += (q ? '&' : '?') + 'apiBase=' + encodeURIComponent(api)
                }
                window.location.replace(`${base}/static/dorm-screen/index.html${q}`)
            },
            meta: {
                title: '宿舍大屏',
                requireAuth: false,
                NoNeedHome: true
            },
            hidden: true
        },
        {
            path: '/LeaveBigScreen', component: LeaveBigScreen, name: 'LeaveBigScreen',
            meta: {
                title: '请假大屏',
                requireAuth: false,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/LeaveOutBigScreen', component: LeaveOutBigScreen, name: 'LeaveOutBigScreen',
            meta: {
                title: '请假离校大屏',
                requireAuth: false,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/DismissalBigScreen', component: DismissalBigScreen, name: 'DismissalBigScreen',
            meta: {
                title: '放学大屏',
                requireAuth: false,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/DismissalBigScreenOld', component: () => import('../views/DismissalBigScreenOld.vue'), name: 'DismissalBigScreenV2',
            meta: {
                title: '放学大屏',
                requireAuth: false,
                NoNeedHome: true
            },
            hidden: true
        },
        {
            path: '/DismissalBigScreenAuto', component: DismissalBigScreenAuto, name: 'DismissalBigScreenAuto',
            meta: {
                title: '放学大屏中转',
                requireAuth: false,
                NoNeedHome: true
            },
            hidden: true
        },
        {
            path: '/SchoolInfoScreen', component: SchoolInfoScreen, name: 'SchoolInfoScreen',
            meta: {
                title: '校园大脑',
                requireAuth: false,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/MoralEducationBigScreen', component: MoralEducationBigScreen, name: 'MoralEducationBigScreen',
            meta: {
                title: '德育大屏',
                requireAuth: false,
                NoNeedHome: true
            },
            hidden: true
        },
        {
            path: '/MoralPointBigScreen', component: MoralPointBigScreen, name: 'MoralPointBigScreen',
            meta: {
                title: '积分大屏',
                requireAuth: false,
                NoNeedHome: true
            },
            hidden: true
        },
        {
            path: '/ZheshangFiveEducationScreen', component: ZheshangFiveEducationScreen, name: 'ZheshangFiveEducationScreen',
            meta: {
                title: '哲商五育大屏',
                requireAuth: false,
                NoNeedHome: true
            },
            hidden: true
        },
        {
            path: '/ZheshangStudentPortraitScreen', component: ZheshangStudentPortraitScreen, name: 'ZheshangStudentPortraitScreen',
            meta: {
                title: '哲商学生画像大屏',
                requireAuth: false,
                NoNeedHome: true
            },
            hidden: true
        },
        {
            path: '/APIDoc', component: APIDoc, name: 'APIDoc',
            meta: {
                title: 'APIDoc',
                requireAuth: false
            },
            hidden: true
        },
        {
            path: '/',
            component: Welcome,
            name: '首页',
            iconCls: 'fa-home',//图标样式class
            // hidden: true,
            meta: {
                title: '首页',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/login',
            component: Login,
            name: 'login',
            iconCls: 'fa-address-card',//图标样式class
            meta: {
                title: '登录',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: "/callback",
            name: "LoginCallbackView",
            component: LoginCallbackView,
            meta: {
                title: '登出',
                NoTabPage: true,
            },
            hidden: true
        },
        {
            path: '*',
            hidden: true,
            redirect: { path: '/404' }
        }
    ]
})

const router = createRouter()

export function filterAsyncRouter(asyncRouterMap) {
    //注意这里的 asyncRouterMap 是一个数组
    const accessedRouters = asyncRouterMap.filter(route => {
        if (route.path && !route.IsButton) {
            if (route.path === '/' || route.path === '-') {//Layout组件特殊处理
                route.component = Layout
            } else {
                try {
                    route.component = _import(route.path.replace('/:id', ''))
                } catch (e) {
                    try {
                        route.component = () => import('@/views' + route.path.replace('/:id', '') + '.vue');
                    } catch (error) {
                        console.info('%c 当前路由 ' + route.path.replace('/:id', '') + '.vue 不存在，因此如法导入组件，请检查接口数据和组件是否匹配，并重新登录，清空缓存!', "color:red")
                    }
                }
            }
        }
        if (route.children && route.children.length && !route.IsButton) {
            route.children = filterAsyncRouter(route.children)
        }
        return true
    })

    return accessedRouters
}

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // the relevant part
}

/**
 * 独立公开展示页（大屏等），无需登录、不应被重定向到登录页。最后更新：2026-07-03
 * @param {object|string} routeOrPath - 路由对象或 path 字符串
 */
export function isPublicStandaloneRoute(routeOrPath) {
    if (!routeOrPath) return false
    if (typeof routeOrPath === 'string') {
        const path = (routeOrPath.split('?')[0] || '').toLowerCase()
        const publicPaths = [
            '/attenbigscreen', '/teacherattenbigscreen', '/dormbigscreen', '/leavebigscreen', '/leaveoutbigscreen',
            '/dismissalbigscreen', '/dismissalbigscreenold', '/dismissalbigscreenauto',
            '/schoolinfoscreen', '/moraleducationbigscreen', '/moralpointbigscreen',
            '/zheshangfiveeducationscreen', '/zheshangstudentportraitscreen',
            '/addapprovalnode', '/homeworkpage', '/404', '/callback', '/apidoc'
        ]
        return publicPaths.includes(path)
    }
    const meta = routeOrPath.meta || {}
    return meta.NoNeedHome === true && routeOrPath.path !== '/login'
}


router.$addRoutes = (params) => {

    var f = item => {

        if (item['children']) {
            item['children'] = item['children'].filter(f);
            return true;
        } else if (item['IsButton']) {
            return item['IsButton'] === false;
        } else {
            return true;
        }

    }

    var params = params.filter(f);

    router.addRoutes(params)
}

export default router;

